import { Brand, createBranded } from '@deltasierra/type-utilities';

export type InAppNotificationId = Brand<number, 'InAppNotificationId'>;
export const InAppNotificationId = createBranded<InAppNotificationId>();
